import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import HotRecommend from './components/HotRecommend';
import CtaSection from './components/CtaSection';
import AboutPreview from './components/AboutPreview';
import TestimonialSection from './components/TestimonialSection';
import StatsAndFAQ from './components/StatsAndFAQ';

export default function Home() {
  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩国漫画网',
    alternateName: '韩漫大全',
    url: 'http://laimim.com/',
    description: '韩国漫画网是专业的韩漫大全平台，为您提供海量免费韩国漫画在线阅读，涵盖全题材并采用便捷的下拉式阅读模式，所有内容免费畅读且每日更新。',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://laimim.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩国漫画网',
    url: 'http://laimim.com/',
    description: '专业的韩国免费漫画在线阅读平台',
    sameAs: ['http://laimim.com/'],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <SEO
        title="韩国免费漫画 - 韩漫大全 - 下拉式漫画在线阅读 - 韩国漫画网"
        description="韩国漫画网是专业的韩漫大全平台，为您提供海量免费韩国漫画在线阅读，涵盖全题材并采用便捷的下拉式阅读模式，所有内容免费畅读且每日更新。"
        keywords="韩国免费漫画,韩漫大全,下拉式阅读,在线看韩漫,韩国漫画网"
        canonicalUrl="http://laimim.com/"
      />

      <Navbar />

      <main>
        <article>
          <HeroSection />
          <CategoryGrid />
          <HotRecommend />
          <CtaSection />
          <AboutPreview />
          <TestimonialSection />
          <StatsAndFAQ />
        </article>
      </main>

      <Footer />
    </>
  );
}
